<template>
  <d-page
    :title="$t('bookkeeping.page-heading')"
    :searchToggle="searchToggle"
    @closeSearch="handleCloseSearch"
    @submitSearch="handleSubmitSearch"
  >
    <template slot="actions">
      <v-btn
        depressed
        large
        class="mr-3 mb-1 mb-sm-0"
        :class="searchToggle ? 'primary--text' : ''"
        @click="searchToggle = !searchToggle"
      >
        <v-icon left> mdi-tune </v-icon>
        <span class="subtitle-2 text-none">{{
          $t("bookkeeping.button.search-toggle")
        }}</span>
      </v-btn>
    </template>
    <template slot="search">
      <Search :months="months" :years="years"></Search>
    </template>
    <template slot="content">
      <List :months="months" :years="years" :startedYear="startedYear"></List>
    </template>
  </d-page>
</template>

<script>
import List from "./List.vue";
import Search from "./Search.vue";
import Months from "@/shared/enums/Months.js";

export default {
  components: {
    List,
    Search,
  },
  data() {
    return {
      searchToggle: false,
      months: [...Months],
      startedYear: 2020,
    };
  },
  computed: {
    years() {
      const currentYear = this.$moment().format("YYYY");

      let years = [];

      for (let i = this.startedYear; i <= currentYear; i++) {
        years.push({ value: i.toString(), displayText: i.toString() });
      }

      return years;
    },
  },
  methods: {
    handleCloseSearch() {
      this.$eventBus.$emit("fetchBookkeeping", true);
    },
    handleSubmitSearch() {
      this.$eventBus.$emit("fetchBookkeeping");
    },
  },
};
</script>
